import React from "react";

import { Switch, Route, Router } from "react-router-dom";

import CreateAccount from "./components/Login/CreateAccountNew";
import Login from "./components/Login/Login";
import PassworRestore from "./components/Login/PassworRestore";
import AthletesCotainer from "./components/pages/Athletes/AthletesCotainer";

import DashportServicesList from "./components/pages/dashportServices/DashportServicesList";
import AboutDashport from "./components/pages/dashportServices/AboutDashport";

import BasketballEventsList from "./components/pages/TeamSports/GameCreate/BasketballEventsList";
import GameContainer from "./components/pages/TeamSports/GameContainer";
import PublicGameContainer from "./components/pages/TeamSports/PublicViews/PublicGameContainer";
import BasketballEventsPublicList from "./components/pages/TeamSports/PublicViews/BasketballEventsPublicList";

export default function Root() {
  return (
    <Switch>
      <Route exact path="/atletas/" component={AthletesCotainer} />

      <Route exact path="/registro" component={CreateAccount} />
      <Route exact path="/login" component={Login} />
      <Route exact path="/password-restore" component={PassworRestore} />
      <Route exact path="/servicios" component={DashportServicesList} />
      <Route exact path="/nosotros" component={AboutDashport} />
      <Route exact path="/basketscorerlist/" component={BasketballEventsList} />
      <Route exact path="/basketscorergame/:gameId" component={GameContainer} />
      <Route exact path="/basketball/" component={BasketballEventsPublicList} />
      <Route exact path="/basketball/:gameId" component={PublicGameContainer} />
      <Route exact path="/" component={BasketballEventsPublicList} />
    </Switch>
  );
}
